import React, { useState, useEffect } from 'react';
import './Hero.css';

const roles = [
  'Innovator.',
  'Designer.',
  'Thinker.',
  'Solver.',
  'Creator.',
  'Developer.',
  'Learner.'
];

const Hero = () => {

  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const currentRole = roles[currentRoleIndex];
    const typeSpeed = isDeleting
      ? 50
      : 100 + Math.random() * 50; // randomized typing speed for realism

    let timeout;

    if (!isDeleting && charIndex < currentRole.length) {
      // typing
      timeout = setTimeout(() => {
        setCurrentText(currentRole.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, typeSpeed);
    } else if (isDeleting && charIndex > 0) {
      // deleting
      timeout = setTimeout(() => {
        setCurrentText(currentRole.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, typeSpeed);
    } else if (!isDeleting && charIndex === currentRole.length) {
      // pause before deleting
      timeout = setTimeout(() => setIsDeleting(true), 1000);
    } else if (isDeleting && charIndex === 0) {
      // move to next role
      setIsDeleting(false);
      setCurrentRoleIndex((prevIndex) => (prevIndex + 1) % roles.length);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, currentRoleIndex]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>

      <div className="container">
        <div className="hero-content fade-in">
          <div className="hero-text">
            <h1 className="hero-title">
              Hi, I'm <span className="hero-name"><br />Agasthya R Kumar</span>
            </h1>
            <div className="hero-subtitle">
              <span>I'm a </span>
              <span className="typed-text">{currentText}</span>
              <span className="cursor">|</span>
            </div>
            <p className="hero-description">
              I create exceptional digital experiences with modern web technologies,
              focusing on performance, accessibility, and stunning design.
            </p>

            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={scrollToContact}>
                Get In Touch
              </button>
              <button className="btn btn-secondary" onClick={scrollToProjects}>
                View My Work
              </button>
            </div>
          </div>

          <div className="hero-image">
            <div className="hero-photo-placeholder">
              <div className="photo-frame">
                <img 
                  src="./profile.jpg" 
                  alt="Agasthya R Kumar" 
                  className="profile-photo" 
                />
              </div>
            </div>
          </div>
        </div>

        <div className="hero-scroll-indicator">
          <div className="scroll-arrow">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
